$(document).ready(function(){
  var hieght = $('.header_announce_sec').innerHeight();
      var hieghts = $('.section-header').innerHeight();
  $('.search_outer_sec').css('top', hieght + 'px');
  $('.header_transparent_home .search_outer_sec').css('top', hieghts + 'px');
  $('.search_outer_sec').css('height', 'calc(100vh - ' + hieght + 'px)');
  $('.header_transparent_home  .search_outer_sec').css('height', 'calc(100vh - ' + hieghts + 'px)');
})

$(window).on('load resize', function(){
  var hieght = $('.header_announce_sec').innerHeight();
  var hieghts = $('.section-header').innerHeight();
  $('.search_outer_sec').css('top', hieght + 'px');
  $('.header_transparent_home .search_outer_sec').css('top', hieghts + 'px');
  $('.search_outer_sec').css('height', 'calc(100vh - ' + hieght + 'px)');
  $('.header_transparent_home  .search_outer_sec').css('height', 'calc(100vh - ' + hieghts + 'px)');
})

$('.search_icon').click(function(){
  $(this).parent().find('.search_outer_sec').slideDown();
  $('html').addClass('serach_open');
})

$('.search-modal__close-button ').click(function(){
  $('.search_outer_sec').slideUp();
  $('html').removeClass('serach_open');
})

$(document).click(function (e) {
  if (!$(e.target).closest(".search_outer_sec, .search_icon").length) { 
    $('.search_outer_sec').slideUp();
    $('html').removeClass('serach_open');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var $carousel = $(".suggention_slider");
  var totalItems = $carousel.find(".item").length;
  $carousel.owlCarousel({
    items: 4,
    loop: true,
    margin: 16,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    dots: false,
    nav: false,
    onTranslated: updateProgress,
    responsive: {
      0: {
        items: 2
      },
  
      600: {
        items: 3
      },
  
      1024: {
        items: 4
      },
  
      1366: {
        items: 4
      }
    }
  });
   
  function updateProgress(event) {
    var index = event.item.index - event.relatedTarget._clones.length / 2;
    var total = event.item.count;
    var current = (index % total + total) % total + 1;
    var percent = (current / total) * 100;
    $(".progress-bar").css("width", percent + "%");
  }
  // Initial call
  updateProgress({ item: $carousel.data('owl.carousel')._items[0], relatedTarget: $carousel.data('owl.carousel') });



  
  const searchInput = document.getElementById('search-input');
  const suggestionsdefault = document.querySelector('.serach_collection_list_items');
  const suggestionsContainer = document.querySelector('.serach_data_col');
  const serachlist = document.querySelector('.search_items_list > ul');
  const notfound = document.getElementById('search_not_found');

  const viewSearch = document.querySelector('.view_search');
  const viewItem = document.querySelector('.view_item');

  suggestionsContainer.style.display = 'none';
  notfound.style.display = 'none';

  searchInput.addEventListener('input', function () {
    const query = searchInput.value.trim();
    let searchTerm = $(this).val().toLowerCase().trim();
    let searchWords = searchTerm.split(/\s+/);

    let $container = $('#mian_search_hader');
    let $items = $container.find('.serch_product_gird');

    if (searchTerm === '') {
      $container.addClass('hidden'); 
      $items.show(); 
      suggestionsdefault.style.display = 'block';
      suggestionsContainer.style.display = 'none';
      return;
    }

    viewSearch.textContent = query;
    $container.removeClass('hidden'); 

    if (query.length > 0) {
      suggestionsdefault.style.display = 'none';
      suggestionsContainer.style.display = 'flex';
      viewItem.innerHTML = '';
    
      Promise.all([
        fetch(`/search/suggest.json?q=${query}&resources[type]=product`),
        fetch(`/search/suggest.json?q=${query}&resources[type]=collection`)
      ])
      .then(responses => Promise.all(responses.map(response => response.json())))
      .then(([productData, collectionData]) => {
        const products = productData.resources.results.products;
        const collections = collectionData.resources.results.collections;        
        const combinedSuggestions = [...products, ...collections];
       
        viewSearch.textContent = query;
        const resultCount = combinedSuggestions.length;
        
        if (resultCount > 0) {
          viewItem.innerHTML += `
              <ul>
                ${combinedSuggestions.map(item => `<li><a href="${item.url}">${item.title}</a></li>`).join('')}
              </ul>
          `;
        }

        if (combinedSuggestions.length > 0) {
          notfound.style.display = 'none';
        } else {
          // serachlist.style.display = 'none';
          notfound.style.display = 'block';
        }
        $items.each(function () {
          let title = $(this).data('title').toLowerCase();
          let isMatch = searchWords.every(word => title.includes(word));  
          if (isMatch) {
            $(this).show();
            notfound.style.display = 'none';
          }
          else if (isMatch.length <= 0){
             notfound.style.display = 'block';
          } else {
            $(this).hide();
          }
          });        
      })
      .catch(error => {
        console.error("❌ Error fetching search suggestions:", error);
      });
    } else {
      suggestionsdefault.style.display = 'block';
      suggestionsContainer.style.display = 'none';
    }
  });

  $('.serach_sec .reset__button ').click(function(){
    const suggestionsdefault1 = document.querySelector('.serach_collection_list_items');
    const suggestionsContainer1 = document.querySelector('.serach_data_col');
    suggestionsContainer1.style.display = 'none';
    notfound.style.display = 'none';
    suggestionsdefault1.style.display = 'block';
    // $carousel.trigger('refresh.owl.carousel');
  })
});



